<template>
  <aside
    v-editable="props.calloutData"
    class="header-callout"
    :class="{
      'active': props.calloutData,
      'visible-on-mobile': props.calloutData?.isVisibleOnMobile,
      'not-visible-on-mobile': !props.calloutData?.isVisibleOnMobile,
      'single': !props.calloutData.title
    }"
  >
    <header>
      <h2>{{ props.calloutData.title }}</h2>
      <WizcoTooltip
        v-if="props.calloutData.infotext.length > 0"
        :blok="props.calloutData.infotext[0]"
      />
    </header>
    <WizcoRichtextResolver class="content" :blok="props.calloutData.content" />
  </aside>
</template>

<script setup>
const props = defineProps({
  calloutData: {
    type: Object,
    required: true
  }
})
</script>

<style scoped>
.header-callout {
  --height-triangle: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--mint-light);
  padding: 0;
  position: relative;
  margin-bottom: 0;
  color: var(--neutral80);
  z-index: 99;
  transition: height var(--time1) ease-in-out;
  animation: wk-showcallout var(--time2) ease-in-out 0ms forwards;
}

.header-callout.callout-leave-active {
  animation-name: wk-hidecallout;
}

.header-callout::after {
  content: '';
  display: block;
  position: absolute;
  bottom: calc(var(--height-triangle) * -1);
  left: 0;
  width: 0;
  height: 0;
  border-top: var(--height-triangle) solid var(--mint-light);
  border-left: 49vw solid transparent;
  border-right: 49vw solid transparent;
}

.header-callout.active {
  padding: 18px 20px 0;
  margin-bottom: calc(var(--height-triangle) - 20px);
}

.header-callout header {
  position: relative;
}

.header-callout header > * {
  font-size: 22px;
  font-weight: 700;
  line-height: 1.36;
  min-height: 1em;
}

.header-callout .content {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.44;
}

.header-callout.single .content {
  font-weight: 300;
}

@keyframes wk-showcallout {
  0% {
    transform: translateY(calc(-100% - var(--height-triangle)));
  }

  100% {
    transform: translateY(0);
  }
}

@keyframes wk-hidecallout {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(calc(-100% - var(--height-triangle)));
  }
}

@media (max-width: 992px) {
  .header-callout.active {
    padding-inline: 70px;
    text-align: center;
  }
}

@media (max-width: 576px) {
  .header-callout.active {
    padding-inline: 1rem;
  }

  .header-callout.not-visible-on-mobile {
    visibility: hidden;
    height: 0;
    padding: 0;
    margin: 0;
  }
}

@media (min-width: 576px) {
  .header-callout.active {
    padding-top: 40px;
  }

  .header-callout .content {
    margin: 10px auto;
    max-width: 600px;
  }

  .header-callout.single .content {
    font-size: 22px;
    font-weight: 500;
  }
}
</style>
